import { setCookie, getCookie } from '../../../js/helpers/helpers';

const displayAgeGate = () => {
	const nav = document.querySelector('.nav-menu');
	nav.classList.add('nav-menu--blurred');

	const content = document.querySelector('.content');
	content.classList.add('content--blurred');

	const footer = document.querySelector('.footer');
	footer.classList.add('footer--blurred');

	const ageGate = document.querySelector('.age-gate-modal-wrapper');
	ageGate.classList.add('age-gate-modal-wrapper--visible');

	document.body.classList.add('age-gate-displayed');

	document.querySelector('[name="viewport"]').content = 'width=device-width, initial-scale=1, maximum-scale=1';
};

const hideAgeGate = () => {
	const nav = document.querySelector('.nav-menu');
	nav.classList.remove('nav-menu--blurred');

	const content = document.querySelector('.content');
	content.classList.remove('content--blurred');

	const footer = document.querySelector('.footer');
	footer.classList.remove('footer--blurred');

	const ageGate = document.querySelector('.age-gate-modal-wrapper');
	ageGate.classList.remove('age-gate-modal-wrapper--visible');

	document.body.classList.remove('age-gate-displayed');

	document.querySelector('[name="viewport"]').content = 'width=device-width, initial-scale=1.0';
};

document.addEventListener('DOMContentLoaded', () => {
	document.querySelector('.age-gate-modal-form').addEventListener('submit', (event) => {
		const day = document.querySelector('.age-gate-modal-day');
		const month = document.querySelector('.age-gate-modal-month');
		const year = document.querySelector('.age-gate-modal-year');

		const remember = document.querySelector('.age-gate-modal-remember-checkbox:checked') !== null;

		const birthDate = Date.parse(`${year.value}/${month.value}/${day.value}`);

		if (parseInt(day.value, 10) && parseInt(month.value, 10) && parseInt(year.value, 10)
				&& parseInt(year.value, 10) > 1900 && birthDate && (Date.now() - birthDate) > 0) {
			const timeDelta = Date.now() - birthDate;
			const age = Math.abs(new Date(timeDelta).getUTCFullYear() - 1970);

			if (age < 19) {
				document.querySelector('.age-gate-modal-error').innerHTML = 'Oops! Unfortunately, you need to be over the age of consent to access this page.';
			} else {
				if (remember) {
					setCookie('age-gate-pass', '1', 30);
				}

				hideAgeGate();
			}
		} else {
			if (!parseInt(day.value, 10) || parseInt(day.value, 10) < 1 || parseInt(day.value, 10) > 31) {
				day.classList.add('age-gate-invalid-date-input');
			} else {
				day.classList.remove('age-gate-invalid-date-input');
			}

			if (!parseInt(month.value, 10) || parseInt(month.value, 10) < 1
						|| parseInt(month.value, 10) > 12) {
				month.classList.add('age-gate-invalid-date-input');
			} else {
				month.classList.remove('age-gate-invalid-date-input');
			}

			if (!parseInt(year.value, 10) || parseInt(year.value, 10) < 1900
						|| parseInt(year.value, 10) > 9999) {
				year.classList.add('age-gate-invalid-date-input');
			} else {
				year.classList.remove('age-gate-invalid-date-input');
			}

			document.querySelector('.age-gate-modal-error').innerHTML = 'Date format invalid';
		}
		event.preventDefault();
	});

	document.querySelector('.age-gate-modal-close').addEventListener('click', () => {
		const a = document.createElement('a');
		a.href = document.referrer;

		if (document.referrer && a.hostname === document.domain && window.history.length > 1) {
			window.history.back();
		} else {
			document.location = '/';
		}
	});

	// if content has adult keywords
	if (document.ageGateIsAdultContent && getCookie('age-gate-pass') !== '1') {
		displayAgeGate();
	}

	document.querySelectorAll('.age-gate-modal-date-input').forEach((item) => {
		item.addEventListener('change', (input) => {
			const changedInput = input;
			if (!Number.isNaN(changedInput.target.value) && changedInput.target.value.length === 1) {
				changedInput.target.value = `0${changedInput.target.value}`;
			}
		});
	});
});

window.addEventListener('player.ready', (event) => {
	const keywords = event
													&& event.detail
													&& event.detail.caller
													&& event.detail.caller.config
													&& event.detail.caller.config.playlist[0]
													&& event.detail.caller.config.playlist[0].metadata
													&& event.detail.caller.config.playlist[0].metadata.keywords;

	// keywords = 'cannabis';

	const ageGatePass = getCookie('age-gate-pass') === '1';

	// if the video has adult keywords
	const containsAdultKeyword = (keywords && (keywords.toLowerCase().includes('cannabis') || keywords.toLowerCase().includes('adult')));
	if (containsAdultKeyword && !ageGatePass) {
		displayAgeGate();
	}
});
